import { useNavigate, useParams } from "react-router";
import BackButton from "../../Components/BackButton";
import CustomButton from "../../Components/CustomButton";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from "../../Components/Loader";
import ProfileDisplay from "../../Components/ProfileDisplay";
import { useCreateChatroomMutation, useGetIssuesQuery } from "../../Redux/Apis/Issue";
import "./style.css";
import { useGetUsersQuery } from "../../Redux/Apis/User";
import { dateFormatter } from "../../Utils";
import CustomInput from "../../Components/CustomInput";
import { useEffect, useState } from "react";

const Chatroom = () => {

    const { id } = useParams();
    const navigate = useNavigate()

    const { data, isLoading, refetch } = useGetIssuesQuery({ id, search: "hehehehe" }, { refetchOnFocus: true });
    const { data: sitters } = useGetUsersQuery({ type: "sitter" })
    const [createChatroom, { isSuccess }] = useCreateChatroomMutation()

    const [form, setForm] = useState({
        sitter: "",
        start_date: "",
        end_date: "",
        total_amount: 0
    })

    useEffect(() => {
        if (isSuccess) {
            navigate('/raise-issues')
        }
    }, [isSuccess])

    const onSubmit = () => {

        console.log(form)
        createChatroom({ ...form, issue: id })

    }

    return (
        <DashboardLayout>
            <div className="dashCard mb-4">
                <div className="row mb-3">
                    <div className="col-12 mb-2">
                        <h2 className="mainTitle">
                            <BackButton />
                            Create Chatroom
                        </h2>
                    </div>
                </div>

                {
                    isLoading ? <Loader /> :
                        <>
                            <div className="row mb-3">
                                <div className="col-12">
                                    <label className="secondaryText">Current Contract Id</label>
                                    <p>{data?.data?.booking?._id}</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-3">
                                    <label className="secondaryText">Sitter Profile</label>
                                    <ProfileDisplay
                                        image={data?.data?.booking?.to_user?.profile_photo}
                                        name={`${data?.data?.booking?.to_user?.first_name} ${data?.data?.booking?.to_user?.last_name}`}
                                        email={data?.data?.booking?.to_user?.email}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="secondaryText">User Profile</label>
                                    <ProfileDisplay
                                        name={`${data?.data?.booking?.from_user?.first_name} ${data?.data?.booking?.from_user?.last_name}`}
                                        email={data?.data?.booking?.from_user?.email}
                                        image={data?.data?.booking?.from_user?.profile_photo}
                                    />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-3">
                                    <label className="secondaryText">Contract Start Date</label>
                                    <p>{dateFormatter(data?.data?.booking?.start_date)}</p>
                                </div>
                                <div className="col-md-3">
                                    <label className="secondaryText">Contract End Date</label>
                                    <p>{dateFormatter(data?.data?.booking?.end_date)}</p>
                                </div>
                                <div className="col-md-3">
                                    <label className="secondaryText">Total Amount</label>
                                    <p>{data?.data?.booking?.total_amount?.toFixed(2)} SAR</p>
                                </div>
                                <div className="col-md-3">
                                    <label className="secondaryText">Service</label>
                                    <p>{data?.data?.booking?.facilitation?.service?.title}</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-3">
                                    <label className="secondaryText">New Sitter</label>
                                    <select className="filterInput" value={form?.sitter} onChange={(e) => {
                                        setForm({ ...form, sitter: e?.target?.value })
                                    }}>
                                        <option value="">Select</option>
                                        {
                                            sitters?.data?.map(item => (
                                                <option key={item._id} value={item?._id}>{item?.first_name} {item?.last_name}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-3">
                                    <CustomInput
                                        value={form?.start_date}
                                        label='Contract Start Date'
                                        required
                                        type='date'
                                        placeholder='Contract Start Date'
                                        labelClass='mainLabel'
                                        inputClass='mainInput'
                                        onChange={(e) => {
                                            setForm({ ...form, start_date: e?.target?.value })
                                        }}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <CustomInput
                                        value={form?.end_date}
                                        label='Contract End Date'
                                        required
                                        type='date'
                                        placeholder='Contract End Date'
                                        labelClass='mainLabel'
                                        inputClass='mainInput'
                                        onChange={(e) => {
                                            setForm({ ...form, end_date: e?.target?.value })
                                        }}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <CustomInput
                                        value={form?.total_amount}
                                        label='Contract Amount'
                                        type="number"
                                        required
                                        placeholder='Contract Amount'
                                        labelClass='mainLabel'
                                        inputClass='mainInput'
                                        onChange={(e) => {
                                            setForm({ ...form, total_amount: e?.target?.value })
                                        }}
                                    />
                                </div>
                            </div>
                            <CustomButton text="Submit" className="primaryButton" onClick={onSubmit} />
                        </>
                }

            </div>
        </DashboardLayout >
    )
}

export default Chatroom